import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The real-time WebCamp bash",
  "description": "",
  "published": "2010-02-21T00:00:00.000Z",
  "redirect_from": ["/blog/the-real-time-webcamp-bash/swizec/1184"],
  "categories": "life, Ljubljana, Monty Python, review, Uncategorized, WebCamp, YouTube",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:CarolCleveland.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/02/300px-CarolCleveland.jpg",
              "alt": "Carol Cleveland as the stereotypical \"blo...",
              "title": "Carol Cleveland as the stereotypical \"blo..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:CarolCleveland.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Yesterday another WebCamp took place in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0513888889,14.5055555556&spn=0.1,0.1&q=46.0513888889,14.5055555556%20(Ljubljana)&t=h",
        "title": "Ljubljana"
      }}>{`Ljubljana`}</a>{` and it was the best `}{`*`}{`camp event I've ever been to. Congrats to all involved in making it happen, you guys rawk.`}</p>
    <p>{`For some strange reason though I seem to have done almost nothing but hang out in the hall and only caught little bits and pieces of the talks here and there.`}</p>
    <p>{`Perhaps the most surprising thing that I learned is that `}<strong parentName="p">{`nobody`}</strong>{` writes good `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Computer_software",
        "title": "Computer software"
      }}>{`software`}</a>{` anymore. Hell, why would you make your `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Algorithm",
        "title": "Algorithm"
      }}>{`algorithms`}</a>{` and page generators run faster ... just slap some `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Cache",
        "title": "Cache"
      }}>{`caching`}</a>{` on there! First you make it cache all `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Database",
        "title": "Database"
      }}>{`database`}</a>{` calls. Then you start saving straight to cache too and sort of make commits to the actual storage happen a bit later when they don't bother the user. If that's not enough you can still just "cache" the whole output of your app in a static html file and serve that. And so on.`}</p>
    <p>{`HELLO guise!? Bad sign (tm) if you need to store the whole output of your software so it runs sufficiently well? O.o What are web developers smoking these days ... I want some.`}</p>
    <p>{`That's the impression I got anyway from so many talks about optimisation and caching ...`}</p>
    <p>{`Another very cool talk, although I wasn't in geek-mode enough to listen in on the whole thing, was by @refaktor who showed some funky simplistic server thingies that can perform `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Real-time_computing",
        "title": "Real-time computing"
      }}>{`real-time`}</a>{` communication amongst each other. I did see the demo and it was very pretty. Hope he puts the code and talk somewhere public so I can give it a study some time.`}</p>
    <p>{`I happened to steal two sessions of people's time. The first was a public release of `}<a parentName="p" {...{
        "href": "http://preona.net/"
      }}>{`LazySharer`}</a>{` that went alright I guess, some things went wrong but it all turned out well in the end.`}</p>
    <p>{`And in a spur-of-the-moment kind of inspiration I also made a talk where we did nothing but watch stupid and silly youtube videos. We burned through our 20+10 minutes and ate away at half of next talk. Sorry Jure, hope you had enough time to talk about `}<a parentName="p" {...{
        "href": "http://www.xmpp.org/",
        "title": "XMPP"
      }}>{`XMPP`}</a>{`.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Flyingcircus_2.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/02/300px-Flyingcircus_2.jpg",
              "alt": "Group shot of the Monty Python crew in 1969",
              "title": "Group shot of the Monty Python crew in 1969"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Flyingcircus_2.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Seeming as how stupid videos were a marginal enough success for my tastes I got together some people and we set up a booth of sorts in the hall where we then played `}<a parentName="p" {...{
        "href": "http://www.pythonline.com/",
        "title": "Monty Python"
      }}>{`Monty Python`}</a>{` and other silly videos for the rest of the day. Well actually we sort of got bored with it and then other people started playing whatever they wanted to see. It was great fun.`}</p>
    <p>{`The WebCamp concluded a bit early because there were no more talks people wanted to give and half the public went MIA. So then the real party started because all the boring people had left.`}</p>
    <p>{`Imagine this scene: 30-ish people, two cases of beer, a lot of pizza, 70 sooper chocolate muffins.`}</p>
    <p>{`Yeah it was a blast. Apparently spiking those muffins with extra sugar and cocoa was the best idea we ever had at Preona. People went berserk for those things, eating three or more and stealing them for home consumption. Hell, if all this Synaptic Web stuff doesn't work out for us we'll open a muffin bakery.`}</p>
    <p>{`Later on when almost everybody had left the evening evolved into Hekovnik's first movie night. Inglorious Basterds on a huge LCD and four people on a sofa munching on stuff. Fun times.`}</p>
    <p>{`Although those people having a brainstorming session on the other side of the room were a bit loud at times :P`}</p>
    <p>{`PS: there were three pizzas (out of 40) left over and no muffins (out of 70). I think this is a great achievement.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/fb4e45dd-b9c7-4bb3-9e97-b49a591159c9/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=fb4e45dd-b9c7-4bb3-9e97-b49a591159c9",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      